import React from 'react';
import { ResponsiveBar } from '@nivo/bar'

export default function Bar2Graph({data}) {

 /* var data = [
    {
      "data": "São José dos Campos",
      "cartao": 150,
      "dinheiro": 66,
      "cheque": 174,
      "boleto": 26,
      "outros": 123,
    },
    {
        "data": "Jacarei",
        "cartao": 150,
        "dinheiro": 66,
        "cheque": 174,
        "boleto": 26,
        "outros": 123,
    },
    {
        "data": "Aparecida",
        "cartao": 150,
        "dinheiro": 66,
        "cheque": 174,
        "boleto": 26,
        "outros": 123,
    },
    {
        "data": "Caraguá",
        "cartao": 150,
        "dinheiro": 66,
        "cheque": 174,
        "boleto": 26,
        "outros": 123,
    },
    {
        "data": "Taubaté",
        "cartao": 150,
        "dinheiro": 66,
        "cheque": 174,
        "boleto": 26,
        "outros": 123,
    }
  ];
  */

return(
  <ResponsiveBar
        data={data}
        keys={[ 'cartao', 'dinheiro', 'cheque', 'boleto', 'outros' ]}
        indexBy="estabelecimento"
        margin={{ top: 5, right: 130, bottom: 80, left: 60 }}
        padding={0.3}
        colors={{ scheme: 'set3' }}
        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 20,
            legend: '',
            legendPosition: 'middle',
            legendOffset: 50
        }}
        axisLeft={{
            tickSize: 2,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'R$ Valor Vendido',
            legendPosition: 'middle',
            legendOffset: -45
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
        legends={[
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
    />
)};